function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ZoomTemplate = require('./zoom.template');
var SaitoOverlay = require('./../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ZoomOverlay = /*#__PURE__*/function () {
  function ZoomOverlay(app, mod) {
    var _this = this;
    _classCallCheck(this, ZoomOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod, false, false, false);
    this.overlay.callback_on_close = function () {
      _this.visible = false;
    };

    //
    // optional callback when selecting spaces via zoom
    //
    this.spaces_onclick_callback = null;
  }
  return _createClass(ZoomOverlay, [{
    key: "remove",
    value: function remove() {
      this.visible = false;
      this.overlay.remove();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "render",
    value: function render() {
      this.visible = true;
      this.overlay.show(ZoomTemplate());
      var container = document.querySelector('.zoom-overlay');
      var originalBoard = document.querySelector('#gameboard');
      var boardClone = document.querySelector('.gameboard-clone');
      if (!originalBoard) {
        return;
      }
      if (!boardClone) {
        boardClone = originalBoard.cloneNode(true);
        boardClone.removeAttribute('id');
        boardClone.removeAttribute('style');
        boardClone.classList.add('gameboard-clone');
        container.appendChild(boardClone);
      }
      if (typeof $ !== 'undefined' && $.fn.draggable) {
        $('.gameboard-clone').draggable({
          cancel: '.country, .country *'
        });
      }
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      if (!this.mod.countries) {
        return;
      }
      var jq = typeof jQuery !== 'undefined' ? jQuery : $;
      var _loop = function _loop(key) {
        var el = document.querySelector(".zoom-overlay .gameboard-clone .".concat(key));
        if (!el) {
          return 1; // continue
        }
        var country_id = key;
        el.onmouseup = function (e) {
          e.stopPropagation();
          if (_this2.spaces_onclick_callback) {
            var selectable = false;
            document.querySelectorAll(".".concat(key)).forEach(function (node) {
              if (node.classList.contains('selectable')) {
                selectable = true;
              }
            });
            if (selectable) {
              _this2.spaces_onclick_callback(country_id);
            }
            return;
          }
          _this2.forwardPlacementToGameboard(country_id, jq);
        };
      };
      for (var key in this.mod.countries) {
        if (_loop(key)) continue;
      }
    }
  }, {
    key: "forwardPlacementToGameboard",
    value: function forwardPlacementToGameboard(country_id, jq) {
      var board = document.getElementById('gameboard');
      if (!board || !jq) {
        return;
      }
      var real = board.querySelector("#".concat(country_id, ".country"));
      if (!real) {
        return;
      }
      var $r = jq(real);

      // Setup / coup paths use .click on .westerneurope / .easterneurope
      if (real.classList.contains('westerneurope') || real.classList.contains('easterneurope')) {
        $r.trigger('click');
        return;
      }

      // Ops placement uses jQuery mousedown + mouseup on #country
      var o = {
        bubbles: true,
        clientX: 0,
        clientY: 0
      };
      $r.trigger(jq.Event('mousedown', o));
      $r.trigger(jq.Event('mouseup', o));
    }
  }, {
    key: "renderAtCountry",
    value: function renderAtCountry() {
      var countrykey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (!this.mod.countries || !this.mod.countries[countrykey]) {
        return;
      }
      var c = this.mod.countries[countrykey];
      this.renderAtCoordinates(c.top, c.left);
    }
  }, {
    key: "renderAtCoordinates",
    value: function renderAtCoordinates() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var scale = 2;
      this.render();
      var zoomOverlay = document.querySelector('.zoom-overlay');
      var board = document.querySelector('.zoom-overlay .gameboard-clone');
      if (!zoomOverlay || !board) return;
      var viewportWidth = zoomOverlay.clientWidth;
      var viewportHeight = zoomOverlay.clientHeight;
      var boardWidth = board.offsetWidth;
      var boardHeight = board.offsetHeight;

      // compute translation in unscaled space
      var translateX = -(x - viewportWidth / (2 * scale));
      var translateY = -(y - viewportHeight / (2 * scale));

      // clamp in unscaled space
      var maxX = 0;
      var maxY = 0;
      var minX = viewportWidth / scale - boardWidth;
      var minY = viewportHeight / scale - boardHeight;
      translateX = Math.min(maxX, Math.max(translateX, minX));
      translateY = Math.min(maxY, Math.max(translateY, minY));
      board.style.transformOrigin = 'top left';
      board.style.transform = "scale(".concat(scale, ") translate(").concat(translateX, "px, ").concat(translateY, "px)");
    }
  }]);
}();
module.exports = ZoomOverlay;